import BrandConfigurationReportTableData from "./BrandConfigurationReportTableData";
import BrandConfigurationReportTableFilter from "./BrandConfigurationReportTableFilter";

const tableHeadings = {
  brand: "Brand",
  affiliate_system: "Affiliate System",
  website: "Website",
  integration_status: "Integration Status",
  stuck_at: "Stuck At",
  reason: "Reason",
  last_run: "Last Run",
  action: "Action",
};
const rows = [
  {
    brand: "Awin",
    affiliate_system: "My Affiliates",
    website: ["B10B"],
    integration_status: "Not Ready",
    stuck_at: "Properties",
    reason: "Missing Mandatory Fields",
    last_run: "Jun. 12, 2025, 04:55 p.m.",
    action: "Continue Setup",
  },
  {
    brand: "CJ Affiliate",
    affiliate_system: "Income Access",
    website: ["BBB"],
    integration_status: "Ready",
    stuck_at: "",
    reason: "",
    last_run: "Feb. 18, 2024, 12:33 p.m.",
    action: "Reconfigure",
  },
  {
    brand: "Awin",
    affiliate_system: "My Affiliates",
    website: ["B10B"],
    integration_status: "Not Ready",
    stuck_at: "Properties",
    reason: "Missing Mandatory Fields",
    last_run: "Jun. 12, 2025, 04:55 p.m.",
    action: "Continue Setup",
  },
  {
    brand: "Awin",
    affiliate_system: "My Affiliates",
    website: ["B10B"],
    integration_status: "Not Ready",
    stuck_at: "Properties",
    reason: "Missing Mandatory Fields",
    last_run: "Jun. 12, 2025, 04:55 p.m.",
    action: "Continue Setup",
  },
  {
    brand: "CJ Affiliate",
    affiliate_system: "Income Access",
    website: ["BBB"],
    integration_status: "Ready",
    stuck_at: "",
    reason: "",
    last_run: "Feb. 18, 2024, 12:33 p.m.",
    action: "Reconfigure",
  },
  {
    brand: "Awin",
    affiliate_system: "My Affiliates",
    website: ["B10B"],
    integration_status: "Not Ready",
    stuck_at: "Properties",
    reason: "Missing Mandatory Fields",
    last_run: "Jun. 12, 2025, 04:55 p.m.",
    action: "Continue Setup",
  },
];

const BrandConfigurationReportTable = () => {
  return (
    <>
      <BrandConfigurationReportTableFilter />
      <BrandConfigurationReportTableData
        tableHeadings={tableHeadings}
        rows={rows}
      />
    </>
  );
};

export default BrandConfigurationReportTable;
